/**
 * This is the securityquestion controller.
 * @memberOf securityquestion Module
 * @namespace securityquestion Controller
 */

/**
 * @name securityquestionController
 * @desc Create the controller.
 * @param $scope
 * @param coreService
 * @memberOf securityquestion Module. securityquestion Controller
 * @ngInject
 */
function securityquestionController() {
}

export default securityquestionController;


// WEBPACK FOOTER //
// ./src/login/securityquestion/securityquestion.controller.js